import {
  useIsMobile,
  useModalContext,
  WSBadge,
  WSButton,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSLayout,
  WSGrid,
  WSScreen,
  WSSwitchInput,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { ResponsiveWingspanLogo } from "../../components/ResponsiveWingspanLogo/ResponsiveWingspanLogo";
import { MembershipPackageCards } from "../components/MembershipPackages/MembershipPackageCards";
import {
  MoneyGuaranteeModal,
  MONEY_GUARANTEE_MODAL
} from "../components/MembershipPackages/MoneyGuaranteeModal";
import { SUBSCRIPTION_PACKAGES_ADDONS } from "../components/MembershipPackages/subscriptionPackages";
import styles from "./MembershipPlansWithAddOns.module.scss";

export const MembershipPlansWithAddOns: React.FC = () => {
  const history = useHistory();
  const isMobile = useIsMobile();
  const { openModal } = useModalContext();
  const [isAnnualBilling, setIsAnnualBilling] = useState(true);
  const onTogglePaymentFrequency = (value: any) => {
    setIsAnnualBilling(value);
  };

  return (
    <WSLayout
      line
      headerCenter={<ResponsiveWingspanLogo />}
      onBack={() => history.goBack()}
    >
      <MoneyGuaranteeModal />
      <WSElement>
        <WSElement py="L">
          <WSGrid.Centered justify="center">
            <WSFlexBox.Center direction="column">
              <WSText.Heading1 mx="M" mb="M">
                {isMobile
                  ? "Choose your membership"
                  : "Which Wingspan membership is right for you?"}
              </WSText.Heading1>
              <WSFlexBox.Center mb="M">
                <WSText.Paragraph
                  mr="S"
                  color={isAnnualBilling ? "grey600" : "grey800"}
                >
                  Monthly billing
                </WSText.Paragraph>
                <WSSwitchInput
                  name="paymentFrequency"
                  value={isAnnualBilling}
                  onChange={onTogglePaymentFrequency}
                  className={styles.toggle}
                />
                <WSText.Paragraph
                  ml="S"
                  color={isAnnualBilling ? "grey800" : "grey600"}
                >
                  Annual billing
                </WSText.Paragraph>
              </WSFlexBox.Center>
              <WSFlexBox.Center mb="XL">
                <WSText.ParagraphSmall mr="XS" inline color="grey600">
                  Get
                </WSText.ParagraphSmall>
                <WSBadge
                  className={styles.annualTip}
                  textProps={{ color: "grey800" }}
                  text="2 months free"
                />
                <WSText.ParagraphSmall ml="XS" inline color="grey600">
                  every year with annual billing.
                </WSText.ParagraphSmall>
              </WSFlexBox.Center>

              <MembershipPackageCards
                mb="XL"
                isAnnualBilling={isAnnualBilling}
                packages={SUBSCRIPTION_PACKAGES_ADDONS.filter(p => !p.isAddOn)}
              />
              <WSText.Heading1 mb="XS">Add-ons</WSText.Heading1>
              <WSText.Paragraph mb="M" color="grey600" mx="S" align="center">
                Customize your membership with additional services
              </WSText.Paragraph>

              <MembershipPackageCards
                mb="XL"
                isAnnualBilling={isAnnualBilling}
                packages={SUBSCRIPTION_PACKAGES_ADDONS.filter(p => p.isAddOn)}
              />

              <WSScreen.TabletAndDesktop>
                <WSFlexBox.Center p="M" className={styles.satisfactionMsg}>
                  <WSFlexBox.Center
                    p="XS"
                    mr="S"
                    className={styles.badgeIconContainer}
                  >
                    <WSIcon name="badge" size="M" color="blue" />
                  </WSFlexBox.Center>
                  <WSText.Paragraph color="grey800" mr="XS">
                    <b>100% satisfaction guaranteed.</b>
                  </WSText.Paragraph>
                  <WSText.Paragraph inline color="grey700" mr="XS">
                    Wingspan backs our product with a{" "}
                    <WSButton.Link
                      onClick={() => openModal(MONEY_GUARANTEE_MODAL)}
                      inline
                    >
                      risk-free, money back guarantee.
                    </WSButton.Link>
                  </WSText.Paragraph>
                </WSFlexBox.Center>
              </WSScreen.TabletAndDesktop>
              <WSScreen.Mobile>
                <WSFlexBox.Center
                  alignItems="flex-start"
                  direction="column"
                  p="M"
                  className={styles.satisfactionMsg}
                >
                  <WSFlexBox.CenterY mb="S">
                    <WSFlexBox.Center
                      p="S"
                      mr="S"
                      className={styles.badgeIconContainer}
                    >
                      <WSIcon name="badge" size="M" color="blue" />
                    </WSFlexBox.Center>
                    <WSText.Paragraph color="grey800" mb="XS">
                      <b>100% satisfaction guaranteed</b>
                    </WSText.Paragraph>
                  </WSFlexBox.CenterY>
                  <WSText.Paragraph inline color="grey700">
                    Wingspan backs our product with a{" "}
                    <WSButton.Link
                      onClick={() => openModal(MONEY_GUARANTEE_MODAL)}
                      inline
                    >
                      risk-free, money back guarantee.
                    </WSButton.Link>
                  </WSText.Paragraph>
                </WSFlexBox.Center>
              </WSScreen.Mobile>
            </WSFlexBox.Center>
          </WSGrid.Centered>
        </WSElement>
      </WSElement>
    </WSLayout>
  );
};
